import { grpc, UI } from '@skedulo/protobuf-web'
import { ListActionsResponse } from '@skedulo/protobuf-web/dist/ui/api/v1/actions'
import { toProto } from '../../../mapping/action-mapping'
import {
  IExtendedUiApiClientOptions,
  IAuthSession,
  IGetActionRequest,
  IAction,
} from '../../../types'
import { IListActionsRequest } from '../../../types'
import { Action, ResolveActionsRequest } from '../../../types/action'
import { FetchApiClient } from '../../fetch-api-client'
import { CacheFactory } from './cache'

const ACTIONS_LIST_CACHE_NAME = 'ActionsList'
const ACTIONS_RESOLVE_CACHE_NAME = 'ActionsResolve'

const ActionsListCache = CacheFactory.create<
  IListActionsRequest,
  ListActionsResponse
>(ACTIONS_LIST_CACHE_NAME)

const ActionsResolveCache = CacheFactory.create<
  ResolveActionsRequest,
  IAction[]
>(ACTIONS_RESOLVE_CACHE_NAME)

export class ActionUiApiClientV1 {
  protected readonly client: UI.API.Client
  protected readonly uiApiRestClient: FetchApiClient
  protected readonly metadata: grpc.Metadata
  protected readonly session: IAuthSession

  constructor(
    { client, metadata, session }: IExtendedUiApiClientOptions,
    uiApiRestClient: FetchApiClient,
  ) {
    this.client = client
    this.metadata = metadata
    this.session = session
    this.uiApiRestClient = uiApiRestClient
  }

  /**
   * Get a single action by id or ActionKey
   */
  getAction = async (request: IGetActionRequest) => {
    return this.client.getAction.call(this.client, request, this.metadata)
  }

  /**
   * Get a list of actions by resource name
   */
  getActionsList = async (request: IListActionsRequest) => {
    return ActionsListCache.execute(request, () =>
      this.client.listActions.call(this.client, request, this.metadata),
    )
  }

  /**
   * Resolve actions
   */
  resolveActions = async (request: ResolveActionsRequest) => {
    return ActionsResolveCache.execute(request, () =>
      this.uiApiRestClient
        .post<Action[]>('/v1/actions/resolve', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request),
        })
        .then((results) => results.map((action) => toProto(action))),
    )
  }
}
